import { useCallback, useRef, useState } from "react";
import { Upload, Loader2 } from "lucide-react";

export default function UploadDropzone({
  onFiles,
  multiple = true,
  accept,
  busy = false,
  label = "Drag & drop or click to upload",
  hint = "",
  testid = "upload-dropzone",
}) {
  const [over, setOver] = useState(false);
  const inputRef = useRef(null);

  const trigger = () => inputRef.current?.click();

  const handleFiles = useCallback(
    (files) => {
      const list = Array.from(files || []);
      if (list.length) onFiles?.(list);
    },
    [onFiles]
  );

  const onDrop = (e) => {
    e.preventDefault();
    setOver(false);
    handleFiles(e.dataTransfer.files);
  };

  const onPaste = (e) => {
    if (!e.clipboardData) return;
    const items = Array.from(e.clipboardData.files || []);
    if (items.length) handleFiles(items);
  };

  return (
    <div
      data-testid={testid}
      role="button"
      tabIndex={0}
      onClick={trigger}
      onPaste={onPaste}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") trigger();
      }}
      onDragOver={(e) => {
        e.preventDefault();
        setOver(true);
      }}
      onDragLeave={() => setOver(false)}
      onDrop={onDrop}
      className={`dropzone ${over ? "active" : ""} rounded-lg p-6 sm:p-8 text-center cursor-pointer select-none`}
    >
      {busy ? (
        <Loader2 className="w-7 h-7 mx-auto mb-2 text-blue-400 animate-spin" />
      ) : (
        <Upload className="w-7 h-7 mx-auto mb-2 text-slate-400" />
      )}
      <div className="font-display font-bold text-slate-100">{label}</div>
      {hint ? <div className="text-xs text-slate-400 mt-1">{hint}</div> : null}
      <input
        ref={inputRef}
        type="file"
        className="hidden"
        multiple={multiple}
        accept={accept}
        onChange={(e) => handleFiles(e.target.files)}
        data-testid={`${testid}-input`}
      />
    </div>
  );
}
